module.exports = __webpack_public_path__ + "static/media/hpb-poster.8b6ac738.png";